import { render } from "./AntepostEventsList.vue?vue&type=template&id=397761ed&scoped=true"
import script from "./AntepostEventsList.vue?vue&type=script&lang=js"
export * from "./AntepostEventsList.vue?vue&type=script&lang=js"

import "./AntepostEventsList.vue?vue&type=style&index=0&id=397761ed&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397761ed"]])

export default __exports__